import React from 'react';
import { Checkbox, InputAdornment, Radio } from '@mui/material';

import { RadioIcon } from '@occc/ui-design-system';

import { GeneralSurveyQuestionType } from '../../types';

type QuestionTypeAdornmentProps = {
  questionType: GeneralSurveyQuestionType;
};

export const QuestionTypeAdornment = ({ questionType }: QuestionTypeAdornmentProps) => {
  if (questionType === 'SurveyQuestionSingleChoice') {
    return (
      <InputAdornment position='start'>
        <Radio checked />
      </InputAdornment>
    );
  }

  if (questionType === 'SurveyQuestionMultipleChoice') {
    return (
      <InputAdornment position='start'>
        <Checkbox checked />
      </InputAdornment>
    );
  }

  return (
    <InputAdornment position='start'>
      <RadioIcon />
    </InputAdornment>
  );
};
